import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AppAlertBanner({}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  if (searchParams.get("type") === "sessionTimeOut") {
    return (
      <div className="h-10 flex justify-center justify-items-center bg-ui-yellow-light text-center ">
        <svg
          className="ui-icon w-4 h-4 mr-2 self-center text-ui-yellow"
          focusable="false"
          aria-hidden="true"
          role="presentation"
        >
          <use href="#ui-icon-circle-solid-exclamation"></use>
        </svg>
        <p className="self-center text-ui-yellow font-semibold">
          {t("AgentAppAlertBanner-InActivityDesc")}
        </p>
      </div>
    );
  }

  return;
}
